import { Quota, QuotaCriteria } from '../models/survey-quota.model';

export class SurveyNestedQuotaKind {
  public static isSimple(quota: Quota): boolean {
    return !SurveyNestedQuotaKind.isCombined(quota);
  }

  public static simple(quotas: readonly Quota[]): Quota[] {
    return quotas.filter((quota) => SurveyNestedQuotaKind.isSimple(quota));
  }

  public static isCombined(quota: Quota): boolean {
    return quota.individualQuotas.length > 0;
  }

  public static combined(quotas: readonly Quota[]): Quota[] {
    return quotas.filter((quota) => SurveyNestedQuotaKind.isCombined(quota));
  }

  public static criteria(quota: Quota): readonly QuotaCriteria[] {
    return SurveyNestedQuotaKind.isCombined(quota)
      ? quota.individualQuotas.flatMap((member) => member.criteria)
      : quota.criteria;
  }
}
